// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./clients/web/src/stylesheets/body/searchResultsList.styl
// module id = 248
// module chunks = 0